export default __webpack_public_path__ + "static/media/duck.b7874ccc.jpg";